<template>
  <b-collapse id="filter-collapse" class="mb-5">
    <div class="card card-custom card-fit">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-12 col-lg-6 mb-5">
            <v-text-field
              v-model="query.candidate_name"
              label="Candidate Name"
              outlined
              dense
              hide-details
              placeholder="Search by candidate name..."
              @keyup.enter="handleApplyFilter"
            ></v-text-field>
          </div>
          <div class="col-sm-12 col-lg-6 mb-5">
            <v-text-field
              v-model="query.interviewer_name"
              label="Interviewer Name"
              outlined
              dense
              hide-details
              placeholder="Search by interviewer name..."
              @keyup.enter="handleApplyFilter"
            ></v-text-field>
          </div>
          <div class="col-sm-12 col-lg-6 mb-5">
            <v-menu
              ref="dateMenu"
              v-model="dateMenu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Date Range"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                range
                no-title
                scrollable
                @input="handleDateChange"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateMenu = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="$refs.dateMenu.save(date)">
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </div>
          <div class="col-sm-12 col-lg-6 mb-5">
            <v-select
              v-model="query.status"
              :items="aiBotResponseStatuses"
              label="Status"
              item-text="name"
              item-value="id"
              outlined
              dense
              hide-details
              multiple
              chips
              small-chips
              deletable-chips
              clearable
            ></v-select>
          </div>
          <div class="col-6 col-lg-6 mb-5">
            <button
              class="btn btn-info font-weight-bolder font-size-h6 px-5 col"
              @click="handleApplyFilter"
            >
              Apply
            </button>
          </div>
          <div class="col-6 col-lg-6 mb-5">
            <button
              class="btn btn-secondary font-weight-bolder font-size-h6 px-5 col"
              @click="handleResetFilter"
            >
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  </b-collapse>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "AIBotResponseFilter",
  data() {
    return {
      query: {
        candidate_name: "",
        interviewer_name: "",
        date: [],
        status: [],
      },
      dateMenu: false,
      statusOptions: [
        { value: "talent_pending_update", text: "Talent Pending Update" },
        { value: "client_pending_update", text: "Client Pending Update" },
        { value: "talent_pending", text: "Talent Pending" },
        { value: "client_pending", text: "Client Pending" },
        { value: "talent_unavailable", text: "Talent Unavailable" },
        { value: "scheduled", text: "Scheduled" },
        { value: "canceled", text: "Canceled" },
        { value: "talent_no_show", text: "Talent No Show" },
        { value: "client_no_show", text: "Client No Show" },
        { value: "completed", text: "Completed" },
        { value: "accepted", text: "Accepted" },
        { value: "rejected", text: "Rejected" },
        { value: "expired", text: "Expired" },
        { value: "hired", text: "Hired" },
      ],
      date: [],
    };
  },
  methods: {
    ...mapActions({
      getStatusOptions: "aiBotResponse/getAIResponseStatuses",
    }),
    handleApplyFilter() {
      const filterQuery = {};

      if (this.query.candidate_name) {
        filterQuery.talent = this.query.candidate_name;
      }

      if (this.query.interviewer_name) {
        filterQuery.client = this.query.interviewer_name;
      }

      if (this.query.status) {
        filterQuery.meeting_status = this.query.status;
      }

      if (this.query.date && this.query.date.length === 2) {
        this.query.date.map((date, index) => {
          if (index === 0) {
            filterQuery[`meeting_start_date[${index}]`] = `${date}`;
          } else {
            filterQuery[`meeting_start_date[${index}]`] = `${date}`;
          }
        });
      }

      this.$emit("applyFilter", filterQuery);
    },
    handleResetFilter() {
      this.query = {
        candidate_name: "",
        interviewer_name: "",
        date: [],
        status: [],
      };
      this.date = [];
      this.$emit("applyFilter", { ...this.query });
    },
    handleDateChange() {
      if (this.date && this.date.length > 1) {
        if (this.date[0] !== this.date[1]) {
          this.date = this.date.sort((a, b) => {
            return new Date(a) - new Date(b);
          });
          this.query.date = this.date.map((date, index) => {
            if (index === 0) {
              return `${date} 00:00:00`;
            } else {
              return `${date} 23:59:59`;
            }
          });
        } else {
          this.query.date = this.date.map((date, index) => {
            if (index === 0) {
              return `${date} 00:00:00`;
            } else {
              return `${date} 23:59:59`;
            }
          });
        }
      }
    },
  },

  computed: {
    ...mapGetters({
      aiBotResponseStatuses: "aiBotResponse/getAIResponseStatuses",
    }),
  },

  mounted() {
    this.getStatusOptions();
  },
};
</script>

<style lang="scss" scoped>
.card-custom {
  border-radius: 0.5rem;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.05);
  border: none;
}

.v-text-field {
  .v-input__slot {
    min-height: 40px !important;
  }
}

.v-select {
  .v-input__slot {
    min-height: 40px !important;
  }
}
</style>
